module.exports = __webpack_public_path__ + "img/thumb_09.408c52bc.jpg";